import '@styles/common.less';
import '@styles/layout.less';
import './contact.less';
import '@common';

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.section .form');
  if (!form) return;

  let submitting = false
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    // 浏览器已校验 required / email，此处构建 JSON 用于后续 fetch
    const payload = {
      name: form.querySelector('[name="name"]').value.trim(),
      phone: form.querySelector('[name="phone"]').value.trim(),
      email: form.querySelector('[name="email"]').value.trim(),
      state: form.querySelector('[name="state"]').value.trim(),
    };
    if (submitting) return
    submitting = true

    fetch('https://services.leadconnectorhq.com/hooks/y37nvPdhbE2ojnYbqFBk/webhook-trigger/0aa31827-9e56-4c34-86b1-798bcafe9ce3', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(res => res.json())
    .then(data => {
      submitting = false
      alert('Your information has been successfully submitted. We will get in touch with you shortly.')
    })
    .catch(err => {
      submitting = false
      alert('Failed to submit, try again later.')
    })
  });
})